'use strict'

// E24-32: shared rounding logic for an order's subtotal/tax/total.
// Previously copy-pasted independently across four display sites
// (app/checkout/tabs-components/order.vue, app/checkout/receipt.vue,
// admin/order/order-detail.vue, common/components/order-detail-popup.vue)
// plus a fifth, unrounded copy feeding the live payment-gateway
// submission (payment-service.js's composePaymentObj()). A plain pure
// function, not part of the Vue.e24-wired service plugin
// (common/e24-services/index.js) -- it has no external dependencies to
// inject.
export function calcOrderTotals (subtotal, tax) {
	const roundedSubtotal = (Math.round(subtotal * 100) / 100).toFixed(2)
	const roundedTax = (Math.round(tax * 100) / 100).toFixed(2)
	// Round the raw sum once, not the sum of the two already-rounded
	// strings -- matches 3 of the 4 original copies (receipt.vue,
	// order-detail.vue, order-detail-popup.vue); only order.vue's
	// original total() summed the rounded strings instead, which can
	// double-round differently at the boundary. Consolidating on the
	// majority (and more correct) behavior.
	const rawTotal = parseFloat(tax) + parseFloat(subtotal)
	const total = (Math.round(rawTotal * 100) / 100).toFixed(2)
	return { subtotal: roundedSubtotal, taxAmount: roundedTax, total }
}



// WEBPACK FOOTER //
// ./src/common/e24-services/order-totals-util.js